import { useState } from 'react'
import {
	EuiButtonEmpty,
	EuiContextMenuPanel,
	EuiContextMenuItem,
	EuiFlexGroup,
	EuiFlexItem,
	EuiPagination,
	EuiPopover,
} from '@equipmentshare/ds2'
import { PaginationProps } from './types'

export default function PaginationEui( { pageCount, activePage, onPageClick, itemsPerPage, setItemsPerPage }: PaginationProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )

	const getIcon = ( itemNumber: number ) => {
		return itemsPerPage === itemNumber ? 'check' : 'empty'
	}

	const closePopover = () => setIsPopoverOpen( false )

	const button = (
		<EuiButtonEmpty
			size="xs"
			color="text"
			iconType="arrowDown"
			iconSide="right"
			onClick={() => setIsPopoverOpen( !isPopoverOpen )}
		>
			Rows per page: {itemsPerPage}
		</EuiButtonEmpty>
	)

	return (
		<EuiFlexGroup
			justifyContent="spaceBetween"
			alignItems="center"
			responsive={false}
			wrap
		>
			<EuiFlexItem grow={false}>
				<EuiPopover
					button={button}
					isOpen={isPopoverOpen}
					closePopover={closePopover}
					panelPaddingSize="none"
				>
					<EuiContextMenuPanel items={[
						<EuiContextMenuItem
							key="10 rows"
							icon={getIcon( 10 )}
							onClick={() => {
								closePopover()
								setItemsPerPage( 10 )
							}}
						>
							10 rows
						</EuiContextMenuItem>,
						<EuiContextMenuItem
							key="20 rows"
							icon={getIcon( 20 )}
							onClick={() => {
								closePopover()
								setItemsPerPage( 20 )
							}}
						>
							20 rows
						</EuiContextMenuItem>,
						<EuiContextMenuItem
							key="50 rows"
							icon={getIcon( 50 )}
							onClick={() => {
								closePopover()
								setItemsPerPage( 50 )
							}}
						>
							50 rows
						</EuiContextMenuItem>,
					]} />
				</EuiPopover>
			</EuiFlexItem>

			<EuiFlexItem grow={false}>
				<EuiPagination
					activePage={activePage}
					onPageClick={onPageClick}
					pageCount={pageCount}
				/>
			</EuiFlexItem>
		</EuiFlexGroup>
	)
}
